import { useState } from "react";

export const SalesRevenueState = () => {
	// PROFESSIONAL SERVICES
	// Inquiries
	const [inqFltrd, setInqFltrd] = useState('All')
	const [inqList, setInqList] = useState([])
	const [inqLoader, setInqLoader] = useState(false)
	const [inqModal, setInqModal] = useState(false)
	const [inqConfirmation, setConfirmation] = useState(false)
	const [inqForm, setInqForm] = useState({
		email: { value: '', stat: false },
		name: { value: '', stat: false },
		contactNo: { value: '', stat: false },
		serviceNeeds: { value: '', stat: false },
		message: { value: '', stat: false },
		source: { value: 'Email', stat: false },
		forwardTo: { value: 'John Doe', stat: false },
	})
	const dfltInqForm = {
		email: { value: '', stat: false },
		name: { value: '', stat: false },
		contactNo: { value: '', stat: false },
		serviceNeeds: { value: '', stat: false },
		message: { value: '', stat: false },
		source: { value: 'Email', stat: false },
		forwardTo: { value: 'John Doe', stat: false },
	}
	const [inqError, setInqError] = useState(false);
	const [inqSending, setInqSending] = useState(false);
	const [inqSuccess, setInqSuccess] = useState(false);
	// Leads
	const [ldsFltrd, setLdsFltrd] = useState('My Leads')
	const [ldsList, setLdsList] = useState([])
	const [ldsLoader, setLdsLoader] = useState(false)

	return {
		// PROFESSIONAL SERVICES
		// Inquiries
		inqFltrd: {data: inqFltrd, set: setInqFltrd},
		inqList: {data: inqList, set: setInqList},
		inqLoader: {data: inqLoader, set: setInqLoader},
		inqModal: {data: inqModal, set: setInqModal},
		inqConfirmation: {data: inqConfirmation, set: setConfirmation},
		inqForm: {data: inqForm, set: setInqForm},
		dfltInqForm: {data: dfltInqForm},
		inqError: {data: inqError, set: setInqError},
		inqSending: {data: inqSending, set: setInqSending},
		inqSuccess: {data: inqSuccess, set: setInqSuccess},
		// Leads
		ldsFltrd: {data: ldsFltrd, set: setLdsFltrd},
		ldsList: {data: ldsList, set: setLdsList},
		ldsLoader: {data: ldsLoader, set: setLdsLoader},
	}
}